"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _react = require("react");

var _material = require("@mui/material");

var _lab = require("@mui/lab");

var _AdapterMoment = _interopRequireDefault(require("@mui/lab/AdapterMoment"));

var _ReadOnlyField = require("../ReadOnlyField");

var _utilities = require("../../utilities");

var _jsxRuntime = require("react/jsx-runtime");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

var moment = new _AdapterMoment.default().moment;

var TimePicker = function TimePicker(_ref) {
  var _sx;

  var _ref$disabled = _ref.disabled,
      disabled = _ref$disabled === void 0 ? false : _ref$disabled,
      _ref$error = _ref.error,
      error = _ref$error === void 0 ? false : _ref$error,
      _ref$format = _ref.format,
      format = _ref$format === void 0 ? "hh:mm A" : _ref$format,
      _ref$fullWidth = _ref.fullWidth,
      fullWidth = _ref$fullWidth === void 0 ? false : _ref$fullWidth,
      _ref$margin = _ref.margin,
      margin = _ref$margin === void 0 ? "none" : _ref$margin,
      _ref$placeholder = _ref.placeholder,
      placeholder = _ref$placeholder === void 0 ? "hh:mm AM" : _ref$placeholder,
      _ref$readOnly = _ref.readOnly,
      readOnly = _ref$readOnly === void 0 ? false : _ref$readOnly,
      _ref$required = _ref.required,
      required = _ref$required === void 0 ? false : _ref$required,
      _ref$value = _ref.value,
      value = _ref$value === void 0 ? null : _ref$value,
      id = _ref.id,
      label = _ref.label,
      onChange = _ref.onChange,
      helperText = _ref.helperText;

  var _useState = (0, _react.useState)(null),
      _useState2 = (0, _slicedToArray2.default)(_useState, 2),
      anchorEl = _useState2[0],
      setAnchorEl = _useState2[1];

  var staticId = (0, _react.useMemo)(function () {
    return id || (0, _utilities.generateId)();
  }, [id]);

  if (readOnly) {
    var content = value ? moment(value).format(format) : null;
    return /*#__PURE__*/(0, _jsxRuntime.jsx)(_ReadOnlyField.ReadOnlyField, {
      content: content,
      label: label
    });
  }

  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_lab.DesktopTimePicker, {
    OpenPickerButtonProps: {
      sx: (_sx = {}, (0, _defineProperty2.default)(_sx, "& .".concat(_utilities.classes.components.MuiSvgIcon.root), {
        height: function height(theme) {
          return theme.spacing(3);
        },
        width: function width(theme) {
          return theme.spacing(3);
        }
      }), (0, _defineProperty2.default)(_sx, "marginRight", 0), _sx)
    },
    PopperProps: {
      anchorEl: anchorEl,
      placement: "bottom-end"
    },
    disabled: disabled,
    inputFormat: format,
    label: label,
    onChange: onChange,
    readOnly: readOnly,
    renderInput: function renderInput(fieldProps) {
      return /*#__PURE__*/(0, _jsxRuntime.jsx)(_material.TextField, _objectSpread(_objectSpread({}, fieldProps), {}, {
        error: error,
        fullWidth: fullWidth,
        helperText: helperText,
        id: staticId,
        inputProps: _objectSpread(_objectSpread({}, fieldProps.inputProps), {}, {
          placeholder: placeholder
        }),
        margin: margin,
        ref: setAnchorEl,
        required: required
      }));
    },
    value: value
  });
};

var _default = TimePicker;
exports.default = _default;